// extracted by mini-css-extract-plugin
export default {"statutory-component":"EditCompany_statutory-component__9ok26","modal-header":"EditCompany_modal-header__3sIIE","modal-header-filter":"EditCompany_modal-header-filter__+DBZa"};